// Module
var code = "<positive-pay-widget></positive-pay-widget> ";
// Exports
module.exports = code;